import AdminsPage from "./pages/AdminsPage";
import AdminCreateWizardPage from "./pages/AdminCreateWizardPage";
import AdminDetailsPage from "./pages/AdminDetailsPage";

/**
 * Gated on the privilege — see the note in chapter/routes.tsx.
 *
 * Creating an admin is kept apart from reading the list: `admin.create` is the
 * privilege that hands somebody the keys, and it is not implied by being able
 * to see who holds them.
 */
export const adminsRoutes = [
  { path: "/admins", element: <AdminsPage />, perms: ["admin.access"] },
  { path: "/admins/new", element: <AdminCreateWizardPage />, perms: ["admin.create"] },
  { path: "/admins/:id", element: <AdminDetailsPage />, perms: ["admin.access"] },
];
